import React from 'react'
import index from "../images/index.jpeg"
function About() {
  return (
    <div className='aboutUs'>
        <img src={index} alt="" />
        <h1>Kissania</h1>
        <p>Kissania is a friend of the Kisaans (farmers) of our country. We will guide you , support you and solve your doubts regarding farming. Kissania comes with an e-commerce platform as well where you can easily sell or buy any farming tools and equipments, as well as blog your views to help other farmer friends. We will answer doubts of each farmer in their desired language. Kissania will be a helping hand and a guide to every farmer of India.</p>
    </div>
  )
}

export default About